import script from "./TrashButton.vue?vue&type=script&setup=true&lang=js"
export * from "./TrashButton.vue?vue&type=script&setup=true&lang=js"

import "./TrashButton.vue?vue&type=style&index=0&id=2750162a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2750162a"]])

export default __exports__